
export const handleFetchTemplatesFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.templates = action.payload.data;
  state.currentPage = action.payload.current_page;
  state.totalPages = action.payload.total_pages;
  state.perPage = action.payload.limit;
  state.totalTemplates = action.payload.total_template_count;
  state.lastUpdated = action.payload.last_updated;
  state.message = action.payload.message;
};

export const handleFetchTemplateWhatsAppFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.templatesWhatsApp = action.payload?.data;
  state.message = action.payload?.message;
};

export const handleFetchModuleFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.moduleList = action.payload.data;
  state.message = action.payload.message;
};

export const handleFetchCategoryFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.categoryList = action.payload.data;
  state.message = action.payload.message;
};

export const handleFetchLanguageFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.languageList = action.payload.data;
  state.message = action.payload.message;
}

export const handleFetchDynamicListFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.dynamicFieldList = action.payload.data;
  state.message = action.payload.message;
};

export const handleAddTemplateFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.templates.push(action.payload.data);
  state.message = action.payload.message;
};

export const handleFetchTemplateByIdFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.currentTemplate = action.payload.data;
};

export const handleDeleteTemplateFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
  //state.currentTemplate = action.payload.data;
};

export const handleUpdateTemplateFulfilled = (state, action) => {
  state.status = 'succeeded';
  const updatedTemplateIndex = state.templates.findIndex(template => template.id === action.payload.data.id);
  if (updatedTemplateIndex !== -1) {
    state.templates[updatedTemplateIndex] = action.payload.data;
  }
  //state.currentTemplate = action.payload.data;
  state.message = action.payload.message;
};


export const handleTemplateNameByFilterFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.templateNameList = action.payload.data;
  state.message = action.payload.message;
};


export const handleTemplateMessageFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};